import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { ClipProject, SubClip, Timed } from '../../../models';
import { SubclipForm } from './subclipForm';
import { cloneDeep } from 'lodash';
import { ClipProjectForm } from './clipProject';

export interface ListItem {
  id: string;
  name: string;
}
export type ClipperState = {
  clipProject: ClipProject | null; // Once
  videoSource: string | null;
  frameRate: number | null;
  videoDuration: number; // Time in seconds. eg. 45.7788879
  isSoundMuted: Boolean;
  timedText: TimedText | null;
  loudnessData: any;
  lastUpdateComponent?: string | null; // Component to last update the state (name + vue unique id).  eg. Player37
  activeSubclip: SubClip | null;
  clipInTime: number | null;
  clipOutTime: number | null;
  activeSubClipIndex: number | null;
  subclipForm: SubClip;
  subClips: SubClip[];
};

export const initialState: ClipperState = {
  clipProject: null,
  videoSource: null,
  frameRate: null,
  videoDuration: 0,
  isSoundMuted: false,
  timedText: null,
  loudnessData: [],
  lastUpdateComponent: null,
  activeSubclip: null,
  clipInTime: null,
  clipOutTime: null,
  activeSubClipIndex: null,
  subclipForm: null,
  subClips: [],
};

const clipperSlice = createSlice({
  name: 'clipper',
  initialState,
  reducers: {
    updateClipProject: (state, action: any) => {
      state.clipProject = action.payload;
    },
    updateSubclips: (state, action: any) => {
      // state.clipProject.subClips = action.payload;
      state.subClips = action.payload;
    },
    updateVideoSource: (state, action: any) => {
      state.videoSource = action.payload;
    },
    updateFrameRate: (state, action: any) => {
      state.frameRate = action.payload;
    },
    updateVideoDuration: (state, action: any) => {
      state.videoDuration = action.payload;
    },
    updateTimedText: (state, action: any) => {
      state.timedText = action.payload;
    },
    updateActiveSubClip: (state, action: any) => {
      state.activeSubclip = action.payload;
    },
    updateActiveSubClipIndex: (state, action: any) => {
      state.activeSubClipIndex = action.payload;
    },
    updateSubclipForm: (state, action: any) => {
      state.subclipForm = action.payload;
    },
    updateClipInTime: (state, action: any) => {
      state.clipInTime = action.payload;
    },
    updateClipOutTime: (state, action: any) => {
      state.clipOutTime = action.payload;
    },
  },
  extraReducers: {},
});

export const {
  updateClipProject,
  updateVideoSource,
  updateFrameRate,
  updateVideoDuration,
  updateTimedText,
  updateActiveSubClip,
  updateActiveSubClipIndex,
  updateSubclipForm,
  updateClipInTime,
  updateClipOutTime,
  updateSubclips,
} = clipperSlice.actions;

// export assetEditorSlice selector to get the slice in any component
export const clipperSelector = (state: RootState) => state.clipperState;
// export The reducer
const clipperReducer = clipperSlice.reducer;
export default clipperReducer;
